import * as bannerStyles from "../../styles/internal-page/banner.module.scss";

import React from "react";
import {toExternalUrl} from "../../utils/utils";

const Banner = ({target, content, actionLabel, title}) => {
    const keydownEventListener = (event) => {
        if (event.key === " " || event.key === "Enter" || event.key === "Spacebar") {
            event.preventDefault();
            typeof window !== `undefined` && window.open(toExternalUrl(target), "_blank")
        }
    }

    return (<div className={bannerStyles.main}>
        <div className={bannerStyles.rootTitle}>
            <div>
                <h2 className={bannerStyles.title}>{title}</h2>
            </div>
            <div className={bannerStyles.margin}>
                <p className={bannerStyles.subtitle}>{content}</p>
            </div>
        </div>

        <div className={bannerStyles.button}>
            <button tabIndex={0}
                 onClick={() => typeof window !== `undefined` && window.open(toExternalUrl(target), "_blank")}
                 onKeyDown={keydownEventListener}
                 style={{padding: "10px"}}
                 className="button"
            >
                <p className={bannerStyles.typobutton}>{actionLabel}</p>
            </button>
        </div>
    </div>);
};

export default Banner;
